import React from 'react';
import './map.scss';

class Map extends React.Component {

  render() {
    return (
      <div className="component map" style={{ height: this.props.height+'px' }}>
        <iframe title={this.props.title} frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src={this.props.src} aria-label={this.props.title}></iframe>        
      </div>
    );
  }

}

export default Map;
